/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Percentage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Percentage 24">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm6.71-.71a.991.991 0 0 1 0 1.402L8.692 16.71a.991.991 0 1 1-1.402-1.402l8.018-8.018a.991.991 0 0 1 1.402 0ZM16 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        className="Union"
        clipRule="evenodd"
      />
      <circle
        cx={12}
        cy={12}
        r={11}
        stroke="#0E0E0E"
        strokeWidth={2}
        className="Ellipse 731"
      />
    </g>
  </svg>
);

export const PercentageIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'percentage-icon'}
      icon={Percentage}
      {...props}
      size={size}
    />
  );
};
